import endpoint from "../../config/endpoints";

export const OutletEnquiryJson = {
    showSaveNextBtn: true,
    apiBaseURL: endpoint.enquiryMaster,
    isEditUrl: endpoint.enquiryMaster + "/detailed-info-by-id?id=",
    isActiveURL: endpoint.enquiryMaster + "/update-is-active-post",
    formPath: "/enquiry-form",
    formPathView: "/enquiry-view",
    screenTitle: "Outlet Enquiry",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Outlet-Enquiry",
    changeExcel: endpoint.exportData,
    showExcelDownload: false,
    excelFileName: "Outlet-Enquiry",
    tab1Label: "All Generated Enquiries",
    tab2Label: "All Visited Enquiries",
    tab3Label: "All Unvisited Enquiries",
    viewTitle: "Outlet Enquiry View",
    searchList: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            isMandatory: true,
            onSubmit: "compare",
        },
        {
            label: "Status",
            controlType: "radiogroup",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "status",
            tableDataKey: "status",
            defaultValue: "1",
            radioGroupItems: [
                {
                    label: "Active",
                    value: "1",
                },
                {
                    label: "Inactive",
                    value: "0",
                },
                {
                    label: "All",
                    value: "2",
                },
            ],
            isMandatory: true,
        },
    ],

    tableColumnsToFilter: [
        {
            columnDisplayName: "Enquiry Name",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "From Date",
            columnKeyName: "fromDate",
            isChecked: true,
        },
        {
            columnDisplayName: "To Date",
            columnKeyName: "toDate",
            isChecked: true,
        },
        {
            columnDisplayName: "Enquiry For",
            columnKeyName: "enquiryFor",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],

    fieldMeta: [
        {
            label: "Beat",
            controlType: "autocomplete",
            placeHolder: "Select Beat ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "beatDetail",
            dataKey: "beatId",
            getListId: "beatId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Order To",
            controlType: "autocomplete",
            placeHolder: "Select Stock Holder ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "stockHolderDetail",
            dataKey: "distributorId",
            isRootLevelKey: true,
            isMandatory: true,
            getListFrom: "beatId",
        },
        {
            label: "Channel",
            controlType: "autocomplete",
            placeHolder: "Select Channel ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "channelDetail",
            dataKey: "channelId",
            getListId: "channelId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Sub Channel",
            controlType: "autocomplete",
            placeHolder: "Select Sub Channel ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "subChannelDetail",
            dataKey: "subChannelId",
            getListId: "subChannelId",
            getListFrom: "channelId",
            isRootLevelKey: true,
            isMandatory: true,
        },

        {
            label: "Outlet Type",
            controlType: "autocomplete",
            placeHolder: "Select Outlet ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "outletTypeDetail",
            dataKey: "outletTypeId",
            getListFrom: "subChannelId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Firm Name",
            controlType: "textfield",
            placeHolder: "Enter Firm Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            uniqueValidation: false,
            dataKey: "firmName",
            isMandatory: true,
        },
        {
            label: "Owner Name",
            controlType: "textfield",
            placeHolder: "Enter Owner Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "ownerName",
            isMandatory: true,
        },
        {
            label: "Mobile Number",
            controlType: "textfield",
            placeHolder: "Enter Mobile Number",
            inputType: "number",
            maxLength: 10,
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "mobileNumber",
            valid: true,
            validName: "phoneNo",
            isMandatory: true,
        },
        {
            label: "Address",
            controlType: "textfield",
            placeHolder: "Enter Address",
            md: 12,
            lg: 12,
            sm: 12,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            dataKey: "address",
            isMandatory: true,
        },
        {
            label: "Address 1",
            controlType: "textfield",
            placeHolder: "Enter Address 1",
            md: 12,
            lg: 12,
            sm: 12,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            dataKey: "address1",
            isMandatory: true,
        },
        {
            label: "Address 2",
            controlType: "textfield",
            placeHolder: "Enter Address 2",
            md: 12,
            lg: 12,
            sm: 12,
            xs: 12,
            labelSM: 2,
            labelMD: 2,
            labelLG: 2,
            valueSM: 10,
            valueMD: 10,
            valueLG: 10,
            dataKey: "address2",
            isMandatory: true,
        },
        {
            label: "Village/City",
            controlType: "textfield",
            placeHolder: "Enter Village/City",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "villageCity",
            isMandatory: true,
        },

        {
            label: "Remark",
            controlType: "textfield",
            placeHolder: "Enter Remark",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "salesTeamRemark",
            isMandatory: true,
        },
        {
            label: "Assign To",
            controlType: "autocomplete",
            placeHolder: "Select Assign To ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "enquiryAllocatedId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Potential",
            controlType: "autocomplete",
            placeHolder: "Select Potential ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "potentialDetail",
            dataKey: "potentialRate",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Platform",
            controlType: "autocomplete",
            placeHolder: "Select Platform ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "platformDetail",
            dataKey: "enquiryRaisedPlatform",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Select Image",
            controlType: "selectImage",
            placeHolder: "Select Image",
            inputType: "number",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKeyToSave: "image",
            dataKey: "productImageShow",
            isMandatory: true,
        },
    ],

    fieldMetaForAdvancedEnquiryMaster: [
        {
            label: "Business Name",
            controlType: "textfield",
            placeHolder: "Enter Business Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            uniqueValidation: false,
            dataKey: "firmName",
            isMandatory: true,
        },
        {
            label: "Type Of Business",
            controlType: "textfield",
            placeHolder: "Enter Type Of Business",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "businessType",
            isMandatory: true,
        },
        {
            label: "Contact Person Name",
            controlType: "textfield",
            placeHolder: "Enter Contact Person Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "ownerName",
            isMandatory: true,
        },
        {
            label: "Contact No",
            controlType: "textfield",
            placeHolder: "Enter Contact No",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "mobileNumber",
            inputType: "number",
            maxLength: 10,
            isMandatory: true,
        },

        {
            label: "Area",
            controlType: "textfield",
            placeHolder: "Enter Area",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "address",
            isMandatory: true,
        },
        {
            label: "City",
            controlType: "textfield",
            placeHolder: "Enter City",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "villageCity",
            isMandatory: true,
        },
        {
            label: "State",
            controlType: "autocomplete",
            placeHolder: "Select State",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "stateDetail",
            dataKey: "stateId",
            isRootLevelKey: true,
            isMandatory: true,
            getListId: "stateId",
        },
        {
            label: "What are you looking for?",
            controlType: "textfield",
            placeHolder: "Enter What are you looking for?",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "requirementType",
            isMandatory: true,
        },
        {
            label: "Products Looking For",
            controlType: "textfield",
            placeHolder: "Enter Products Looking For",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "productsLookingFor",
            isMandatory: true,
        },
        {
            label: "Remark",
            controlType: "textfield",
            placeHolder: "Enter Remark",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "salesTeamRemark",
            isMandatory: true,
        },
        {
            label: "Sales Person Contact No",
            controlType: "textfield",
            placeHolder: "Enter Sales Person Contact No",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "salesPersonContactNo",
            inputType: "number",
            maxLength: 10,
            isMandatory: true,
        },
        {
            label: "Initial Enquiry Assign To",
            controlType: "autocomplete",
            placeHolder: "Select Assign To ",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "enquiryAllocatedId",
            isRootLevelKey: true,
            isMandatory: true,
            getListFrom: "stateId",
            getListId: "enquiryAllocatedId",
        },
        {
            label: "Enquiry Forwarded To",
            controlType: "autocomplete",
            placeHolder: "Select Enquiry Forwarded To",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "enquiryForwardedToDetails",
            dataKey: "enquiryForwardedToId",
            isRootLevelKey: true,
            isMandatory: false,
            getListFrom: "enquiryAllocatedId",
        },
        {
            label: "Action Taken",
            controlType: "textfield",
            placeHolder: "Enter Action Taken",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "actionTaken",
            isMandatory: false,
        },
        {
            label: "Final Outcome",
            controlType: "textfield",
            placeHolder: "Enter Final Outcome",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "outcomeStatus",
            isMandatory: false,
        },
    ],

    fieldMetaForConvert: [
        {
            label: "Owner Name",
            controlType: "textfield",
            placeHolder: "Enter Owner Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "ownerName",
            isMandatory: true,
        },
        {
            label: "Mobile Number",
            controlType: "textfield",
            placeHolder: "Enter Mobile Number",
            inputType: "number",
            maxLength: 10,
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "mobileNumber",
            valid: true,
            validName: "phoneNo",
            isMandatory: true,
        },
        {
            label: "Village/City",
            controlType: "textfield",
            placeHolder: "Enter Village/City",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "villageCity",
            isMandatory: true,
        },
        {
            label: "Remark",
            controlType: "textfield",
            placeHolder: "Enter Remark",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "salesTeamRemark",
            isMandatory: false,
        },
    ]
};
